import { RequiredArticle } from '../../../interfaces/Article';

export interface RequiredProductDelta {
  representativeArticle: RequiredArticle;
  delta: number;
}

export const calculateProductDeltas = (
  previous: RequiredArticle[],
  current: RequiredArticle[],
): RequiredProductDelta[] => {
  const delta: RequiredProductDelta[] = [];
  const previousGrouped = groupByProductNumber(previous);
  const currentGrouped = groupByProductNumber(current);

  for (const productNumber in previousGrouped) {
    const firstPreviousArticle = previousGrouped[productNumber][0];
    const previousAmount = previousGrouped[productNumber].length;
    const currentAmount = currentGrouped[productNumber] ? currentGrouped[productNumber].length : 0;
    delta.push({
      representativeArticle: firstPreviousArticle,
      delta: currentAmount - previousAmount,
    });
  }

  for (const productNumber in currentGrouped) {
    if (!previousGrouped[productNumber]) {
      const firstPreviousArticle = currentGrouped[productNumber][0];
      const currentAmount = currentGrouped[productNumber].length;
      delta.push({ representativeArticle: firstPreviousArticle, delta: currentAmount });
    }
  }

  return delta;
};

const groupByProductNumber = (articles: RequiredArticle[]): Map<string, RequiredArticle[]> => {
  return articles.reduce(function (map, article) {
    const productNumber = article.number.substring(0, 6);
    map[productNumber] = map[productNumber] || [];
    map[productNumber].push(article);
    return map;
  }, new Map());
};
